module.exports = __webpack_public_path__ + "static/img/karate.f9cdcc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/karate.png
// module id = 4pPw
// module chunks = 0